import { h } from 'preact';
import {Button as StyledButton} from "./styled";

const Button = ({ className, children, text, ...rest }) => {
  return (
    <StyledButton className={className} {...rest}>{text || children}</StyledButton>
  );
};

export default Button;
